<script setup lang="ts">
import { FileCog, MessageSquareText } from 'lucide-vue-next';

defineProps<{
  type: 'single' | 'double';
  isTyping?: boolean;
}>();

defineEmits<{
  (e: 'scrollToEditor'): void;
}>();
</script>

<template>
  <div class="bet-slip-preview-parity dark">
    <div class="bet-slip-header">Bet ({{ type === 'single' ? '1 selection' : '2 selections' }})</div>
    <div class="bet-slip-event-card">
      <div class="event-info">
        <div class="event-teams">West Ham - Arsenal</div>
        <div class="event-meta">Sun 16:30 • Premier League</div>
      </div>

      <!-- Single Selection -->
      <template v-if="type === 'single'">
        <div class="selection-row">
          <div class="selection-main">
            <div class="selection-name">Arsenal</div>
            <div class="market-name">Full Time</div>
          </div>
          <div class="odds-box">@1.53</div>
        </div>
      </template>

      <!-- Double Selection -->
      <template v-else>
        <div class="selection-stack merged-odds">
          <div class="selections-group">
            <div class="selection-row">
              <div class="selection-main">
                <div class="selection-name">Arsenal</div>
                <div class="market-name">Full Time</div>
              </div>
            </div>
            <div class="selection-row border-top">
              <div class="selection-main">
                <div class="selection-name">Bukayo Saka - Yes</div>
                <div class="market-name">To Score</div>
              </div>
            </div>
          </div>
          <div class="odds-box merged">@3.60</div>
        </div>
      </template>

      <div class="bet-slip-actions">
        <div class="action-btn red" @click="$emit('scrollToEditor')">Editor <FileCog :size="14" /></div>
        <div class="action-btn red feedback">Feedback <MessageSquareText :size="14" /></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bet-slip-preview-parity { margin-top: 24px; border-radius: 12px; overflow: hidden; border: 1px solid rgba(255,255,255,0.05); background: #111113; }
.bet-slip-header { background: #e21b0d; color: #fff; padding: 10px 16px; font-weight: 800; font-size: 0.9rem; }
.bet-slip-event-card { padding: 16px; display: flex; flex-direction: column; gap: 12px; }
.event-teams { color: #fff; font-weight: 700; font-size: 1rem; }
.event-meta { color: #71717a; font-size: 0.75rem; margin-top: 2px; }
.selection-row { background: #000; border-radius: 4px; padding: 12px 16px; display: flex; justify-content: space-between; align-items: center; border-left: 3px solid #e21b0d; }
.selection-name { color: #fff; font-weight: 800; font-size: 0.95rem; }
.market-name { color: #71717a; font-size: 0.8rem; margin-top: 2px; }
.odds-box { color: #a1a1aa; font-weight: 600; font-size: 0.9rem; padding-left: 12px; border-left: 1px solid rgba(255,255,255,0.1); min-width: 50px; text-align: right; }
.selection-stack { display: flex; flex-direction: column; background: #000; border-radius: 4px; border-left: 3px solid #e21b0d; overflow: hidden; }
.selection-stack.merged-odds { flex-direction: row; align-items: stretch; }
.selection-stack.merged-odds .selections-group { flex-grow: 1; display: flex; flex-direction: column; }
.selection-stack.merged-odds .odds-box.merged { 
  display: flex; 
  align-items: center; 
  justify-content: center; 
  padding: 0 16px;
  background: rgba(255,255,255,0.02);
  min-width: 70px;
}
.selection-row.border-top { border-top: 1px solid rgba(255,255,255,0.05); }
.bet-slip-actions { display: flex; justify-content: space-between; align-items: center; margin-top: 8px; }
.action-btn.red { background: #e21b0d; color: #fff; padding: 8px 16px; border-radius: 6px; font-weight: 800; font-size: 0.85rem; display: flex; align-items: center; gap: 8px; transition: background 0.2s ease; }
.action-btn.red:not(.feedback) { cursor: pointer; }
.action-btn.red:not(.feedback):hover { background: #ff2d1c; }
.action-btn.red.feedback { background: #e21b0d; cursor: default; }
</style>
